import { startApp } from './app';
startApp().catch(err => {
  throw err;
});